export const defaultTheme = {
  colors: {
    white: '#FFFFFF',
    grayExtraLight: '#FCFDFE',
    grayBackground: '#F7F8FC',
    grayLightest: '#F0F1F7',
    grayDividerGraph: '#EBEDF0',
    grayDivider: '#DFE0EB',
    grayLight: '#C5C7CD',
    gray: '#9FA2B4',
    grayDark: '#4B506D',
    modalOverlay: '#4B506D3D',
    modalOverlayDarker: '#4B506D99',
    lightBlack: '#525252',
    black: '#252733',
    yellow: '#FEA500',
    orange: '#FFA600',
    green: '#00DA8B',
    lightBlue: '#E7EAFF',
    blue: '#018EFF',
    blueDark: '#253DD9',
    saturatedBlue: '#0022FF',
    lightestPurple: '#E0D4F8',
    lightPurple: '#8355E2',
    purple: '#642ADB',
    midDarkPurple: '#9A53CB',
    darkPurple: '#4B20A4',
    accentLightest: '#DDE2FF',
    accentLight: '#2137C3',
    accent: '#253292',
    accentDark: '#182161',
    pink: '#FF4EA1',
    pinkLight: '#FF81BC',
    red: '#FE2142',
    redLight: '#FFF7F7',
    primary: '#642ADB',
    pastelGreen: '#93EDCA',
    pastelYellow: '#F6D061',
    pastelBlue: '#A6DEFF',
    pastelPurple: '#C9B6F2',
    pastelPink: '#F4BDE7',
    pastelRed: '#FFB0B0',
    lilac: '#B26EFF',
    calendarBlack: '#1F1F1F',
    lavenderLightest: '#F2EFFC'
  },
  fonts: {
    Poppins: 'Poppins',
    GloriaHallelujah: 'Gloria Hallelujah'
  },
  borders: {
    smallBorderRadius: '4px',
    bigBorderRadius: '8px'
  },
  breakpoints: {
    xs: '400px',
    sm: '600px',
    md: '900px',
    lg: '1280px',
    xl: '1440px',
    xxl: '1920px',
    xxxl: '2560px'
  }
} as const;
